<template>
    <ManageLayout title="TCPA Shield">
        <TcpaShieldTableControls />

        <TcpaShieldTable />
    </ManageLayout>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

import ManageLayout from '@/layouts/ManageLayout.vue'
import TcpaShieldTableControls from '@/views/call-tracking/tcpa-shield/components/controls/TcpaShieldTableControls.vue'
import TcpaShieldTable from '@/views/call-tracking/tcpa-shield/components/tables/TcpaShieldTable.vue'

import { useSortFilterTableStore } from '@/store/sortFilterTableStore'
import { usePermissionsStore } from '@/store/permissionsStore'
import { useTcpaShieldStore } from '@/store/call-tracking/suppressionList/tcpaShieldStore'

import { ROUTES } from '@/constants/routes'
import { SETTINGS_HEADER_TABLE } from '@/constants/headersTable/settingsHeaderTable'
import { TCPA_SHIELD_HEADERS } from '@/constants/headersTable/tcpaShieldHeadersTable'

const sortFilterTableStore = useSortFilterTableStore()
const permissionsStore = usePermissionsStore()
const tcpaShieldStore = useTcpaShieldStore()

const nextRoute = ref('')

onMounted(() => {
    sortFilterTableStore.initializeTableSettings(SETTINGS_HEADER_TABLE.tcpaShield)
    sortFilterTableStore.setHeaders(SETTINGS_HEADER_TABLE.tcpaShield, TCPA_SHIELD_HEADERS)
    sortFilterTableStore.getQueryLocalStorage(SETTINGS_HEADER_TABLE.tcpaShield)
    tcpaShieldStore.getLocalStorageOnPage()
    tcpaShieldStore.goToLoadTcpaShieldFiltersAndSorting()
    tcpaShieldStore.goToLoadTcpaShield()

    if (permissionsStore.permissions.tcpaShield.edit) {
        tcpaShieldStore.goToLoadCreateDataForTcpaShield()
    }
})

onBeforeRouteLeave((to, from, next) => {
    nextRoute.value = to.name

    next()
})

onUnmounted(() => {
    if (nextRoute.value !== ROUTES.detailTcpaShield) {
        tcpaShieldStore.$reset()
    }

    tcpaShieldStore.clearItems()
    sortFilterTableStore.removeFilter(SETTINGS_HEADER_TABLE.tcpaShield)
})
</script>
